import type { Project } from "@/views/project/project";
import { getLookupByMurn } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Project) {
  entity._authRequestFields = ["id", "statusMurn"];
  return entity;
}
function getInitialData() {
  const result = {} as Project; //TODO: ts
  return addAuthRequestFields(result);
}
async function skinnyResponseAdapter(response: { data: Project }) {
  addAuthRequestFields(response.data);
  return response.data;
}
async function responseAdapter(response: { data: Project }) {
  response.data = await skinnyResponseAdapter(response);
  response.data.status = await getLookupByMurn(response.data.statusMurn);
  return response.data;
}
function requestAdapter(data: Project) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Project) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Project) {}
